<template>
  <div class="media-player-modal">
    <BModal :active="isModalOpen" :width="`1854px`" :full-screen="isMobile">
      <div class="media-player-modal__content">
        <div class="media-player-modal__content__close-button" @click="onClickClose">
          <div>Cerrar</div>
          <div>
            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_close.png" alt="cerrar" />
          </div>
        </div>
        <div class="media-player-modal__content__header">
          <Header />
        </div>
        <div class="media-player-modal__content__body">
          <Body ref="body" :is-mobile="isMobile" />
        </div>
      </div>
    </BModal>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import axios from 'axios';

const subcategoriesExceptions = [];
const rivalTransformCategories = ['g-23', 'g-24', 'g-25'];
const categoriesTypes = {
  player: 1,
  team: 2,
  goalkeeper: 3,
};

export default {
  name: 'MediaPlayerModal',
  components: {
    BModal: async () => {
      const { BModal } = await import('buefy/dist/esm/modal');
      return BModal;
    },
    Header: () => import('@/components/Sections/MediaPlayer-v3/modal-mode/Header'),
    Body: () => import('@/components/Sections/MediaPlayer-v3/modal-mode/Body'),
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['windowWidth']),
    ...mapState('mediaModal', ['advancedFilterCategories', 'modalInitialState', 'advancedFilterCategoriesRaw']),
    isMobile() {
      return this.windowWidth < 600;
    },
    isModalOpen() {
      return this.$store.state.mediaModal.isModalOpen;
    },
  },
  methods: {
    ...mapMutations('mediaModal', [
      'setModalInitialState',
      'setAdvancedFilterCategories',
      'setAdvancedFilterCategoriesRaw',
    ]),
    async fillAdvancedFilterCategories() {
      try {
        let mainCategories = [];
        if (this.advancedFilterCategories.isEmpty) {
          mainCategories = await this.fetchCategories();
          this.setAdvancedFilterCategoriesRaw({
            ...mainCategories,
            mainCategoriesIds: this.modalInitialState.categoryIds,
          });
        } else {
          mainCategories = this.advancedFilterCategoriesRaw;
        }
        const mainCategoriesAux = [];
        if (mainCategories && mainCategories.length) {
          const filledCategories = mainCategories.reduce(
            (accumulator, mainCategory) => {
              const mainCategoryAux = {
                idAux: mainCategory.group_id,
                ids: [
                  ...(mainCategory.ids ? mainCategory.ids : []),
                  ...(mainCategory.rival_Ids ? mainCategory.rival_Ids : []),
                ],
                type: mainCategory.type,
                name: mainCategory.name,
                coordinatePoint: mainCategory.coordinate_point,
                requiresRivalTransform: rivalTransformCategories.includes(mainCategory.group_id),
              };
              mainCategoryAux.idsAux = [...mainCategoryAux.ids];
              (mainCategoryAux.subcategoryGroups =
                mainCategory.group_id === 'g-12'
                  ? []
                  : this.getSubcategoryGroups(mainCategory, 0, new Map(), false, {}, mainCategoryAux.idsAux)),
                mainCategoriesAux.push(mainCategoryAux);
              if (mainCategoryAux.type.includes(categoriesTypes.player)) {
                accumulator.player.push(mainCategoryAux);
              }
              if (mainCategoryAux.type.includes(categoriesTypes.team)) {
                accumulator.team.push(mainCategoryAux);
              }
              if (mainCategoryAux.type.includes(categoriesTypes.goalkeeper)) {
                accumulator.goalkeeper.push(mainCategoryAux);
              }
              return accumulator;
            },
            {
              games: [],
              player: [],
              team: [],
              goalkeeper: [],
              isEmpty: false,
            },
          );
          this.setAdvancedFilterCategories(filledCategories);
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    async fetchCategories() {
      try {
        const response = await axios.get(
          'https://2gfppi9wb6.execute-api.us-east-2.amazonaws.com/prod/videos/categories',
        );
        return response.data || [];
      } catch (e) {
        return Promise.reject(e);
      }
    },
    getSubcategoryGroups(
      category,
      groupLevel = 0,
      subcategoriesGroupsByLevel = new Map(),
      isRival = false,
      fatherCategory = {},
      mainCategoryIds = [],
    ) {
      if (!category.group_id) {
        return;
      }
      let subcategoriesByLevel = subcategoriesGroupsByLevel.get(groupLevel);
      const categoryId = isRival ? `${category.id_category}_r` : category.id_category;
      if (category.id_category) {
        mainCategoryIds.push(category.id_category);
      }
      let subcategoryAux = {
        ids: [categoryId],
        groupId: category.group_id,
        level: groupLevel,
        name: category.name,
        isSelected: true,
        fatherCategories: groupLevel > 0 ? [fatherCategory] : [],
        idsByFatherCategory: {
          [category.category_father]: [categoryId],
        },
      };
      if (groupLevel > 0) {
        if (groupLevel === 1) {
          subcategoryAux.id = category.id_category;
        }
      }
      if (subcategoriesByLevel && groupLevel !== 0) {
        const charAux = category.group_id.charAt(category.group_id.length - 1);
        const sameTopicSubcategory = subcategoriesByLevel.find(subcategory => subcategory.groupId.endsWith(charAux));
        if (sameTopicSubcategory && !subcategoriesExceptions.includes(subcategoryAux.groupId)) {
          subcategoryAux = sameTopicSubcategory;
          sameTopicSubcategory.ids.push(categoryId);
          sameTopicSubcategory.fatherCategories.push(fatherCategory);
          sameTopicSubcategory.fatherCategories.forEach(fatherCate => {
            if (fatherCate.childCategories) {
              const childAdded = fatherCate.childCategories.find(
                childCategory => childCategory.groupId === subcategoryAux.groupId,
              );
              if (!childAdded) {
                fatherCate.childCategories.push(subcategoryAux);
              }
            } else {
              fatherCate.childCategories = [subcategoryAux];
            }
          });
          if (sameTopicSubcategory.idsByFatherCategory[category.category_father]) {
            sameTopicSubcategory.idsByFatherCategory[category.category_father].push(categoryId);
          } else {
            sameTopicSubcategory.idsByFatherCategory[category.category_father] = [categoryId];
          }
        } else {
          subcategoryAux.fatherCategories.forEach(fatherCate => {
            if (fatherCate.childCategories) {
              const childAdded = fatherCate.childCategories.find(
                childCategory => childCategory.groupId === subcategoryAux.groupId,
              );
              if (!childAdded) {
                fatherCate.childCategories.push(subcategoryAux);
              }
            } else {
              fatherCate.childCategories = [subcategoryAux];
            }
          });
          subcategoriesByLevel.push(subcategoryAux);
        }
      } else if (groupLevel !== 0) {
        if (fatherCategory.childCategories) {
          fatherCategory.childCategories.push(subcategoryAux);
        } else {
          fatherCategory.childCategories = [subcategoryAux];
        }
        subcategoriesByLevel = [subcategoryAux];
        subcategoriesGroupsByLevel.set(groupLevel, subcategoriesByLevel);
      }
      if (category.categories && category.categories.length) {
        category.categories.forEach(subcategory => {
          this.getSubcategoryGroups(
            subcategory,
            groupLevel + 1,
            subcategoriesGroupsByLevel,
            isRival,
            subcategoryAux,
            mainCategoryIds,
          );
        });
      } else if (category.rival_categories && category.rival_categories.length) {
        category.rival_categories.forEach(subcategory => {
          this.getSubcategoryGroups(
            subcategory,
            groupLevel + 1,
            subcategoriesGroupsByLevel,
            true,
            subcategoryAux,
            mainCategoryIds,
          );
        });
      }
      if (groupLevel === 0) {
        return Array.from(subcategoriesGroupsByLevel.values());
      }
    },
    onClickClose() {
      this.$refs.body.beforeClose();
      this.$store.commit('mediaModal/setCurrentPlaylistPlays', []);
      this.$store.commit('mediaModal/setIsModalOpen', false);
      this.$store.commit('mediaModal/setCurrentPlayerQueue', []);
    },
  },
  beforeDestroy() {
    this.setModalInitialState({});
  },
};
</script>

<style lang="scss" scoped>
.media-player-modal {
  &__content {
    font-size: 1rem;
    border-radius: 1.5em;
    box-shadow: 0 16px 34px 0 rgba(0, 0, 0, 0.25);
    background-color: #fff;
    padding: 2.5em 2em 2em 2em;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    &__close-button {
      position: absolute;
      top: 4px;
      right: 4px;
      padding: 0.2em 1em;
      font-family: Roboto-Regular, sans-serif;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.47;
      letter-spacing: -0.15px;
      color: white;
      border-radius: 1.25em;
      background-color: #132839;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      & > div:first-child {
        margin-right: 0.8em;
      }

      & img {
        height: 0.6em;
        width: 0.6em;
      }
    }

    &__header {
      width: 100%;
    }

    &__body {
      margin-top: 1.5em;
      width: 100%;

      @media screen and (max-width: 510px) {
        margin-top: 0.5em;
      }
    }
  }

  @media screen and (max-width: 600px) {
    &__content {
      //height: 100%;
      border-radius: 0;
      box-shadow: unset;
    }
  }

  @media screen and (max-width: 768px) {
    &__content {
      padding: 3em 0 0 0;

      &__header {
        padding: 0 0.1em;
      }
    }
  }
}
</style>
<style lang="scss">
.media-player-modal {
  & button.modal-close.is-large {
    display: none;
  }


  /* Anchura del scrollbar */
  ::-webkit-scrollbar {
    width: 4px;
  }

  & .modal-content,
  .modal-card {
    overflow: auto !important;
  }
}
</style>
